import { checkRequiredValidationAction } from "../../../Actions/LogicActions/ServiceRequest/CheckRequiredValidationAction";
import { getBookingTripDetailsAction } from "../../../Actions/LogicActions/ServiceRequest/GetBookingTripDetails";
import { getServiceRequestCategories } from "../../../Actions/LogicActions/ServiceRequest/GetServiceRequestCategories";
import { onChangePassengerCheckBoxAction } from "../../../Actions/LogicActions/ServiceRequest/OnChangePassengerCheckBoxAction";
import { onChangeServiceRequestCategories } from "../../../Actions/LogicActions/ServiceRequest/OnChangeServiceRequestCategories";
import { onChangeServiceRequestControlsAction } from "../../../Actions/LogicActions/ServiceRequest/OnChangeServiceRequestControlsAction";
import { resetAtomForFieldAction } from "../../../Actions/LogicActions/ServiceRequest/ResetAtomForFieldAction";
import { saveServiceRequestAction } from "../../../Actions/LogicActions/ServiceRequest/SaveServiceRequestAction";
import { setAdditionalFieldsAction } from "../../../Actions/LogicActions/ServiceRequest/SetAdditionalFieldsAction";
import { successClosedModalAction } from "../../../Actions/LogicActions/ServiceRequest/SuccessClosedModalAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { IGetBookingDetailsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { IOnChangePassengerCheckBoxActionParams, IOnChangeServiceRequestCategories, IOnChangeServiceRequestControlsActionParams, ISaveServiceRequestActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ServiceRequestActionParams";
import { IResetAtomForFieldActionParams } from "../../../Orchestrator/Types/Interface/IServiceRequest";
import { ServiceRequestClaimContext } from "../Context/ServiceRequestClaimContext";
import { getRecoilStateValue } from "../../../Orchestrator/Recoils/Events/Recoil";

class ServiceRequestClaimInitStep extends StepFlow {
    get stepName() { return "ServiceRequestClaimInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IGetBookingDetailsActionParams, void>({
                eventName: srReqClaimTree.Booking.GetDetails,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<ServiceRequestClaimContext>("serviceRequestClaimContext");
                        if (context) {
                            getBookingTripDetailsAction.setParams({
                                bookingId: data.bookingId,
                                direction: data.direction
                            })
                            await getBookingTripDetailsAction.execute();
                            context.bookingId = data.bookingId;
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: srReqClaimTree.Category.Get,
                handler: async ({ data }) => {
                    const context = this.getCtx<ServiceRequestClaimContext>("serviceRequestClaimContext");
                    if (context && data) {
                        await getServiceRequestCategories.setParams(data);
                        await getServiceRequestCategories.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IOnChangeServiceRequestCategories, void>({
                eventName: srReqClaimTree.Category.onChange,
                handler: async ({ data }) => {
                    const context = this.getCtx<ServiceRequestClaimContext>("serviceRequestClaimContext");
                    if (context && data) {
                        onChangeServiceRequestCategories.setParams(data)
                        await onChangeServiceRequestCategories.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveServiceRequestActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.RequiredValidation,
                handler: async ({ data }) => {
                    if (data) {
                        checkRequiredValidationAction.setParams(data);
                        await checkRequiredValidationAction.execute();
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: srReqClaimTree.RequestClaim.setFields,
                handler: async () => {
                    setAdditionalFieldsAction.setParams();
                    await setAdditionalFieldsAction.execute();
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IOnChangeServiceRequestControlsActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.handleChange,
                handler: async ({ data }) => {
                    if (data) {
                        onChangeServiceRequestControlsAction.setParams(data)
                        await onChangeServiceRequestControlsAction.execute()
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IOnChangePassengerCheckBoxActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.OnPassengerCheckBoxChange,
                handler: async ({ data }) => {
                    if (data) {
                        onChangePassengerCheckBoxAction.setParams(data)
                        await onChangePassengerCheckBoxAction.execute()
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<boolean, void>({
                eventName: srReqClaimTree.RequestClaim.SuccessModal,
                handler: async ({ data }) => {
                    successClosedModalAction.setParams(data || false)
                    await successClosedModalAction.execute();
                    if (isActionRunSuccessfully(successClosedModalAction)) {
                        const result = successClosedModalAction.result!
                        if (result.status === "success") {
                            this.next();
                            const lastPageVisited = getRecoilStateValue<string>("lastVisitedPageForServiceRequestAtom") || "";
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: lastPageVisited || "/"
                            })
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IResetAtomForFieldActionParams, void>({
                eventName: srReqClaimTree.Reset.Atom,
                handler: async ({ data }) => {
                    if (data) {
                        resetAtomForFieldAction.setParams(data?.backClick || "")
                        await resetAtomForFieldAction.execute()
                        if (isActionRunSuccessfully(resetAtomForFieldAction)) {
                            const result = resetAtomForFieldAction?.result
                            if (result?.status === "success") {
                                this.next();
                                if (data?.backClick === "backClick") {
                                    _eventBus.emit({
                                        eventName: "FLOW_CLOSE",
                                        data: "ServiceRequestClaimFlow"
                                    })
                                    if (data?.lastPageVisited) {
                                        _eventBus.emit({
                                            eventName: "ROUTE_CHANGE",
                                            data: data?.lastPageVisited
                                        });
                                    } else {
                                        _eventBus.emit({
                                            eventName: "ROUTE_CHANGE",
                                            data: "/bookings"
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveServiceRequestActionParams, void>({
                eventName: srReqClaimTree.RequestClaim.Save,
                handler: async ({ data }) => {
                    if (data) {
                        saveServiceRequestAction.setParams(data)
                        await saveServiceRequestAction.execute()
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        const context = this.getCtx<ServiceRequestClaimContext>("serviceRequestClaimContext");
        if (!context) {
            this.setCtx("serviceRequestClaimContext", new ServiceRequestClaimContext());
        }
        _eventBus.emit<void, void>({
            eventName: srReqClaimTree.RequestClaim.FlowStarted,
        })
        console.log("Service Request Claim Init Step Execute...")
    }
}

export const ServiceRequestClaimInitStepDeclaration = new StepDefinition({
    stepName: "ServiceRequestClaimInit_Step",
    stepClass: ServiceRequestClaimInitStep
});